// Armageddon's asset-library finalize endpoint rejects images over its 15MB cap
// with a 422 JSON:API error whose source.pointer is '/file_size'. The @rest
// directive in apps/api forwards those errors on graphQLErrors[].extensions.errors.
export const IMAGE_TOO_LARGE_MESSAGE = 'Image exceeds the 15MB size limit. Please upload a smaller file.';

type JsonApiError = { source?: { pointer?: string } };

type GraphQLErrorLike = { extensions?: Record<string, unknown> } | null;

const isFileSizeValidationError = (e: unknown): boolean => {
  const graphQLErrors = (e as { graphQLErrors?: GraphQLErrorLike[] } | null)?.graphQLErrors;
  if (!Array.isArray(graphQLErrors)) return false;
  return graphQLErrors.some((gqlError) => {
    const errors = gqlError?.extensions?.errors;
    return Array.isArray(errors) && (errors as (JsonApiError | null)[]).some((err) => err?.source?.pointer === '/file_size');
  });
};

export const getUploadErrorMessage = (e: unknown): string => {
  if (isFileSizeValidationError(e)) return IMAGE_TOO_LARGE_MESSAGE;
  return e instanceof Error ? e.message : String(e);
};
